(function($) {
    'use strict';

    class Form {
        constructor() {
            this.errors = {
                empty: 'Detta fält är obligatoriskt',
                select: 'Vänligen välj ett alternativ',
                maxCost: 'Kostnader kan inte vara högre än intäkter'
            };
            this.init();
            this.bindEvents();
        }

        init() {
            this.$form = $('.salary-calculator__form');
            this.$fields = this.$form.find('.salary-calculator__form__field');
            this.$firstField = this.$fields.first();
            this.$calculateButton = this.$form.find('.calculate-button');
            this.$numberInputs = this.$form.find('.number-input');
            this.$getResultsPopup = this.$form.parent().siblings('.sc_get_calculation_results');
            this.$getResultButton = this.$form.find('.salary-calculator__show-resut-btn')
            this.bolagsform = this.$form.find('[name="salary-calculator__form__field-bolagsform"]');
            this.age = this.$form.find('[name="salary-calculator__form__field-födelseår"]');
            
            this.$firstField.addClass('active');
            this.formatNumberInputs();
        }

        bindEvents() {
            // Валидация при вводе
            this.$form.on('input change', 'input, select', (e) => {
                const $field = $(e.target).closest('.salary-calculator__form__field');
                if ($(e.target).val()) {
                    $field.removeClass('has-error');
                }
            });

            // Валидация поля косты
            this.$form.find('[name="salary-calculator__form__field-kostnader"]').on('input change', (e) => {
                this.validateKostnader(e.target);
            });

            // Очистка ошибки косты при изменении интактера
            this.$form.find('[name="salary-calculator__form__field-intäkter"]').on('input', () => {
                this.clearKostnaderError();
            });

            // Форматирование чисел
            this.$numberInputs.on('input', (e) => {
                const input = e.target;
                input.value = input.value.replace(/[^\d\s]/g, '');
                this.formatNumber(input);
            });
        }

        // Форматирование всех числовых полей при инициализации
        formatNumberInputs() {
            this.$numberInputs.each((_, input) => {
                this.formatNumber(input);
            });
        }

        // Форматирование отдельного числового поля
        formatNumber(input) {
            // Сохраняем позицию курсора
            const start = input.selectionStart;
            const end = input.selectionEnd;

            // Получаем значение и убираем все кроме цифр
            let value = input.value.replace(/[^\d]/g, '');
            
            if (value) {
                // Форматируем число слева направо
                const parts = [];
                for (let i = value.length; i > 0; i -= 3) {
                    parts.unshift(value.slice(Math.max(0, i - 3), i));
                }
                const formattedValue = parts.join(' ');

                // Сохраняем оригинальное значение для расчетов
                input.dataset.value = value;

                // Определяем, сколько пробелов было до курсора
                const beforeCursor = input.value.substr(0, start);
                const oldSpaces = (beforeCursor.match(/\s/g) || []).length;
                
                // Обновляем значение
                input.value = formattedValue;
                
                // Определяем, сколько пробелов стало до курсора
                const newSpacesBefore = (formattedValue.substr(0, start).match(/\s/g) || []).length;
                const spaceDiff = newSpacesBefore - oldSpaces;
                
                // Корректируем позицию курсора
                const newPosition = start + spaceDiff;
                try {
                    input.setSelectionRange(newPosition, newPosition);
                } catch (e) {
                    // Игнорируем ошибку для полей, которые не поддерживают выделение
                }
            } else {
                input.value = '';
                input.dataset.value = '';
            }
        }

        validateKostnader(input) {
            const $kostnaderField = $(input).closest('.salary-calculator__form__field');
            const kostnaderValue = this.getNumberValue(input);
            const intakterValue = this.getNumberValue(
                this.$form.find('[name="salary-calculator__form__field-intäkter"]')[0]
            );

            if (kostnaderValue > intakterValue) {
                $kostnaderField.addClass('has-error');
                $kostnaderField.find('.field-error').text(this.errors.maxCost);
                
                // Добавляем плавный скролл к полю с ошибкой
                $('html, body').animate({
                    scrollTop: $kostnaderField.offset().top - 100
                }, 500);
            } else {
                $kostnaderField.removeClass('has-error');
                $kostnaderField.find('.field-error').text('');
            }
        }

        clearKostnaderError() {
            const $kostnaderField = this.$form.find('[name="salary-calculator__form__field-kostnader"]')
                .closest('.salary-calculator__form__field');
            $kostnaderField.removeClass('has-error');
            $kostnaderField.find('.field-error').text('');
        }

        getNumberValue(input) {
            const value = input.dataset.value;
            return value ? parseInt(value, 10) : 0;
        }

        validateForm() {
            let isValid = true;

            this.$fields.removeClass('has-error').find('.field-error').text('');

            const intakterValue = this.getNumberValue(
                this.$form.find('[name="salary-calculator__form__field-intäkter"]')[0]
            );
            const kostnaderValue = this.getNumberValue(
                this.$form.find('[name="salary-calculator__form__field-kostnader"]')[0]
            );

            this.$fields.each((_, field) => {
                const $field = $(field);
                const $input = $field.find('input, select');
                const $error = $field.find('.field-error');

                if ($input.is('select')) {
                    if (!$input.val()) {
                        isValid = false;
                        $field.addClass('has-error');
                        $error.text(this.errors.select);
                        this.$form.removeClass('calculated')
                    }
                } else if ($input.hasClass('number-input')) {
                    if (!$input.val() || $input.val().replace(/\s/g, '') === '') {
                        isValid = false;
                        $field.addClass('has-error');
                        this.$form.removeClass('calculated')
                        $error.text(this.errors.empty);
                    }
                    else if ($input.attr('name') === 'salary-calculator__form__field-kostnader' && 
                             kostnaderValue > intakterValue) {
                        isValid = false;
                        $field.addClass('has-error');
                        $error.text(this.errors.maxCost);
                        this.$form.removeClass('calculated')
                    }
                } else if ($input.attr('type') === 'radio') {
                    const name = $input.attr('name');
                    if (!$(`input[name="${name}"]:checked`).length) {
                        isValid = false;
                        $field.addClass('has-error');
                        $error.text(this.errors.empty);
                        this.$form.removeClass('calculated')
                    }
                }
            });

            return isValid;
        }

        getFormData() {
            const formData = {};
            
            this.$fields.each((_, field) => {
                const $field = $(field);
                const $input = $field.find('input, select');
                
                if ($input.attr('type') === 'radio') {
                    const name = $input.attr('name');
                    formData[name] = $(`input[name="${name}"]:checked`).val();
                } else if ($input.hasClass('number-input')) {
                    formData[$input.attr('name')] = this.getNumberValue($input[0]);
                } else {

                    if($input.attr('name') === 'salary-calculator__form__field-kommun') {
                        formData[$input.attr('name')] = $input.val();
                        formData[$input.attr('name') + '-funeral-fee'] = $input.find('option:selected').data('funeral-fee');
                    }else{
                        formData[$input.attr('name')] = $input.val();
                    }

                }
                
            });
            
            return formData;
        }
    }

    window.Form = Form;

})(jQuery); 